export const profiles = {
  client: {
    uid: "4HWBr3Mom4cmpxFIcG9Eyk1JOiC3",
    displayName: "Fabricio Ismael Murillo",
    photoURL: "/client.png",
  },
  bot: {
    uid: "wfdfsdfsdfd53453454",
    displayName: "Los Gophers Hermanos",
    photoURL: "/gophers.png",
  },
};
